import queryString from "query-string";
import React, { Component } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import { map } from "lodash";

import BouncingLoader from "components/EnergyCompany/BouncingLoader/BouncingLoader.jsx";
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { authenticateUser } from "reducers/user/actions";
import { confirmacaoEmail } from "services/auth";

const styles = {
  loader: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  titleActions: {
    color:  "#3C4858",
    display: "flex",
    fontSize: "2.6em",
    justifyContent: "center",
  },
};

class ConfirmacaoEmailPage extends Component {
  state = {
    confirmando: true,
    errors: null,
    msg: "Estamos confirmando seu email",
  };

  componentDidMount() {
    const { authenticateUser, history, location } = this.props;
    const { codigo, id } = queryString.parse(location.search);

    confirmacaoEmail({ codigo, id })
      .then(({ data }) => {
        this.setState({ confirmando: false, msg: "Confirmado, redirecionando para o dashboard" });
        authenticateUser(data);

        setTimeout(() => {
          history.push("/dashboard");
        }, 2000);
      })
      .catch(({ response }) => {
        this.setState({
          confirmando: false,
          errors: response.data,
          msg: "Erro na confirmação",
        });
      });
  }

  render() {
    const { classes } = this.props;
    const { confirmando, errors, msg } = this.state;

    return (
      <div className={classes.container}>
        <GridContainer alignContent="center" justify="center">
          <GridItem md={10} sm={12} xs={12}>
            <ECCard
              content={
                <div className={classes.loader}>
                  {confirmando && <BouncingLoader />}
                  {map(errors, (error, index) => (
                    <h4 key={index}>
                      {error}
                    </h4>
                  ))}
                  {errors && (
                    <h4>Por favor enviar um email para <a href="mailto:contato@energycompany.com.br">contato@energycompany.com.br</a></h4>
                  )}
                </div>
              }
              title={msg}
              titleActionsClass={classes.titleActions}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

ConfirmacaoEmailPage.propTypes = {
  authenticateUser: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

const mapDispatchToProps = {
  authenticateUser,
};

export default connect(null, mapDispatchToProps)(withStyles(styles)(ConfirmacaoEmailPage));



// WEBPACK FOOTER //
// ./src/views/Pages/ConfirmacaoEmailPage.jsx